// AutoInsurance.js
import React from 'react';
import { Field, ErrorMessage } from 'formik';

const AutoInsurance = () => {
  return (
    <div className="h-100">
      <div className="row h-100 align-items-center">
        <div className="col-12 col-xs-12 col-md-12 px-0">
          <div className="general-info-form py-5">
            <div className="row">
              <div className="col-12 p-0">
                <p className="llc-text pb-3">
                Are you interested in automated validation of a guest’s personal auto insurance?
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-xs-12 col-md-6 p-0 pe-md-2">
                <div className="form-check ps-0">
                  <Field
                    type="radio"
                    id="autoInsuranceYes"
                    name="automated_validation"
                    value="Yes"
                    className="form-check-input"
                  />
                  <label
                    className="form-check-label form-check-field w-100"
                    htmlFor="autoInsuranceYes"
                  >
                    <div className="row">
                      <div className="col-12 p-0">
                        <div className="row">
                          <div className="col-10 ps-0">
                            <img
                              src="/img/beta-signup/logo-icon.svg"
                              className="img-fluid"
                              alt="Yes, automated ID validation"
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 ps-0">
                            <p className="llc-heading mb-0">Yes</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div className="col-12 col-xs-12 col-md-6 mt-3 mt-md-0 p-0 ps-md-2">
                <div className="form-check ps-0">
                  <Field
                    type="radio"
                    id="autoInsuranceNo"
                    name="automated_validation"
                    value="No"
                    className="form-check-input"
                  />
                  <label
                    className="form-check-label form-check-field w-100"
                    htmlFor="autoInsuranceNo"
                  >
                    <div className="row">
                      <div className="col-12 p-0">
                        <div className="row">
                          <div className="col-10 ps-0">
                            <img
                              src="/img/beta-signup/student-card.svg"
                              className="img-fluid"
                              alt="No automated ID validation"
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 ps-0">
                            <p className="llc-heading mb-0">No</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <ErrorMessage name="automated_validation" component="div" className="invalid-feedback" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoInsurance;
